@import '../general';
@import 'checkbox';

:host[disabled] {
  pointer-events: none;
}
